const e = {
  name: "Number8Filled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 9V11H11V9H13Z" fill="currentColor"/>
<path d="M11 15V13H13V15H11Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM9 7H15V17H9V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Number8Filled
};
